(function () {
  'use strict';

  const CUTOFF_HOUR = 13;
  const MAX_ATTEMPTS = 80;
  const RETRY_MS = 100;
  let FLATPICKR_LIBRARY = typeof window.flatpickr === 'function' ? window.flatpickr : null;
  let FLATPICKR_ES_LOCALE = window.flatpickr?.l10ns?.es
    ? Object.assign({}, window.flatpickr.l10ns.es)
    : null;
  let ACTIVE_DELIVERY_INSTANCE = null;
  function loadFlatpickr() {
    if (FLATPICKR_LIBRARY) return Promise.resolve(FLATPICKR_LIBRARY);
    if (window.DTDeliveryFlatpickrPromise) return window.DTDeliveryFlatpickrPromise;

    const scripts = Array.from(document.scripts);
    const coreSource = scripts.find(script => /flatpickr\.min\.js/.test(script.src))?.src;
    const localeSource = scripts.find(script => /flatpickr-es\.js/.test(script.src))?.src;

    function loadScript(source) {
      return new Promise((resolve, reject) => {
        if (!source) {
          reject(new Error('No se encontró el recurso de Flatpickr'));
          return;
        }
        const script = document.createElement('script');
        script.src = source;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    window.DTDeliveryFlatpickrPromise = Promise.resolve()
      .then(() => typeof window.flatpickr === 'function' ? null : loadScript(coreSource))
      .then(() => window.flatpickr?.l10ns?.es ? null : loadScript(localeSource))
      .then(() => {
        FLATPICKR_LIBRARY = window.flatpickr;
        FLATPICKR_ES_LOCALE = window.flatpickr?.l10ns?.es
          ? Object.assign({}, window.flatpickr.l10ns.es)
          : FLATPICKR_ES_LOCALE;
        return FLATPICKR_LIBRARY;
      })
      .catch(error => {
        window.DTDeliveryFlatpickrPromise = null;
        throw error;
      });

    return window.DTDeliveryFlatpickrPromise;
  }


  function isoDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function shopifyDate(date) {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}${month}${year}`;
  }

  function parseSavedDate(value) {
    const clean = String(value || '').trim();
    let parts;

    if (/^\d{8}$/.test(clean)) {
      parts = [Number(clean.slice(4, 8)), Number(clean.slice(2, 4)), Number(clean.slice(0, 2))];
    } else if (/^\d{4}-\d{2}-\d{2}$/.test(clean)) {
      parts = clean.split('-').map(Number);
    } else {
      return null;
    }

    const date = new Date(parts[0], parts[1] - 1, parts[2]);
    return date.getFullYear() === parts[0] &&
      date.getMonth() === parts[1] - 1 &&
      date.getDate() === parts[2] ? date : null;
  }

  function blockedDates() {
    const container = document.querySelector('#site-cart-sidebar .dt-delivery-date');
    return container && container.dataset.dtBlockedDates
      ? container.dataset.dtBlockedDates.split(',').map(value => value.trim()).filter(Boolean)
      : [];
  }

  function isAvailable(date) {
    return date.getDay() !== 0 && date.getDay() !== 1 && !blockedDates().includes(isoDate(date));
  }

  function firstAvailableDate() {
    const now = new Date();
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    date.setDate(date.getDate() + (now.getHours() < CUTOFF_HOUR ? 1 : 2));
    while (!isAvailable(date)) date.setDate(date.getDate() + 1);
    return date;
  }

  function saveDate(value) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Fecha de entrega': value } })
    }).catch(error => console.error('DOÑA TOMASA - Error guardando fecha de entrega:', error));
  }

  window.dtInitDeliveryDate = function dtInitDeliveryDate(attempt = 0) {
    const input = document.getElementById('DTDeliveryDate');
    if (!input) {
      if (attempt < MAX_ATTEMPTS) {
        window.setTimeout(() => window.dtInitDeliveryDate(attempt + 1), RETRY_MS);
      }
      return;
    }
    if (input._flatpickr || input.dataset.dtDeliveryReady === 'true') return;

    const flatpickrLibrary = typeof window.flatpickr === 'function'
      ? (FLATPICKR_LIBRARY = window.flatpickr)
      : FLATPICKR_LIBRARY;

    if (window.flatpickr?.l10ns?.es) {
      FLATPICKR_ES_LOCALE = Object.assign({}, window.flatpickr.l10ns.es);
    }

    if (typeof flatpickrLibrary !== 'function' || !FLATPICKR_ES_LOCALE) {
      if (attempt < MAX_ATTEMPTS) {
        loadFlatpickr()
          .then(() => window.dtInitDeliveryDate(attempt + 1))
          .catch(error => console.error('DOÑA TOMASA - Error cargando calendario:', error));
      }
      return;
    }

    try {
      document.querySelectorAll('.flatpickr-calendar, .s2m-flatpickr-calendar').forEach(calendar => calendar.remove());
      input.parentElement.querySelectorAll('input.form-control').forEach(field => field.remove());

      const savedValue = input.dataset.savedDate || input.value || '';
      const holidays = blockedDates();
      const instance = flatpickrLibrary(input, {
        locale: Object.assign({}, FLATPICKR_ES_LOCALE, { firstDayOfWeek: 1 }),
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        minDate: isoDate(firstAvailableDate()),
        allowInput: false,
        disableMobile: true,
        disable: [date => date.getDay() === 0 || date.getDay() === 1, ...holidays],
        onChange(selectedDates) {
          saveDate(shopifyDate(selectedDates && selectedDates.length ? selectedDates[0] : null));
        }
      });

      ACTIVE_DELIVERY_INSTANCE = instance;

      if (instance && instance.calendarContainer) {
        const ensureCalendarIsConnected = () => {
          if (!instance.calendarContainer.isConnected) {
            document.body.appendChild(instance.calendarContainer);
          }
        };
        ensureCalendarIsConnected();
        window.setTimeout(ensureCalendarIsConnected, 100);
      }

      const savedDate = parseSavedDate(savedValue);
      if (savedDate && instance && typeof instance.setDate === 'function') {
        instance.setDate(savedDate, false);
      }
      input.dataset.dtDeliveryReady = 'true';
    } catch (error) {
      console.error('DOÑA TOMASA - Error inicializando fecha de entrega:', error);
      if (attempt < MAX_ATTEMPTS) {
        window.setTimeout(() => window.dtInitDeliveryDate(attempt + 1), RETRY_MS);
      }
    }
  };

  document.addEventListener('submit', function (event) {
    if (!event.target || event.target.id !== 'cart') return;
    const input = document.getElementById('DTDeliveryDate');
    if (input && input._flatpickr && input._flatpickr.selectedDates.length) {
      input.value = shopifyDate(input._flatpickr.selectedDates[0]);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.flatpickr-calendar, .s2m-flatpickr-calendar')) return;

    const trigger = event.target.closest('#site-cart-sidebar .dt-delivery-date');
    if (!trigger || !ACTIVE_DELIVERY_INSTANCE) return;

    const calendar = ACTIVE_DELIVERY_INSTANCE.calendarContainer;
    if (calendar && !calendar.isConnected) document.body.appendChild(calendar);

    if (typeof ACTIVE_DELIVERY_INSTANCE.open === 'function') {
      ACTIVE_DELIVERY_INSTANCE.open();
    }
  }, true);

  const deliveryDateObserver = new MutationObserver(function () {
    const input = document.getElementById('DTDeliveryDate');
    if (input && !input._flatpickr && input.dataset.dtDeliveryReady !== 'true') {
      window.dtInitDeliveryDate();
    }
  });
  deliveryDateObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.dtInitDeliveryDate(), { once: true });
  } else {
    window.dtInitDeliveryDate();
  }
})();
